var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-8"},[_c('v-img',{attrs:{"src":_vm.imgAgenda,"eager":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }